import { render, staticRenderFns } from "./Francesinha.vue?vue&type=template&id=13b7686a&"
import script from "./Francesinha.vue?vue&type=script&lang=js&"
export * from "./Francesinha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports